import React from 'react';
import { Col, Row, Image, Paragraph } from 'Common';
import VideoModal from './VideoModal';
import TextBlock from './TextBlock';
import { TEXT } from 'locales/translations';
import VideoImage from 'images/home/video_borist.png';
import { VideoSectionStyle } from './VideoSection.style';

export const VideoSection = () => {
  return (
    <VideoSectionStyle
      backgroundColor="lightGrey"
      verticalPadding={{ sm: 40, md: 60, lg: 80 }}
      className="video-section"
      id="video-section"
    >
      <Row>
        <Col xs={{ size: 12 }} md={{ size: 6, offset: 0 }} lg={{ size: 6, offset: 0 }} className="image-wrapper">
          <Image alt={TEXT.videoSection.alt} src={VideoImage} className="video-image" />
        </Col>
        <Col xs={{ size: 12 }} md={{ size: 6, offset: 0 }} lg={{ size: 6, offset: 0 }} className="content-wrapper">
          <TextBlock heading={TEXT.videoSection.heading} body={TEXT.videoSection.subline} />
          <Paragraph dangerouslySetInnerHTML={{ __html: TEXT.videoSection.body }} />
          <VideoModal />
        </Col>
      </Row>
    </VideoSectionStyle>
  );
};
